/* Maison Skin — Clinical Glass theme: AJAX cart drawer (free-shipping meter,
   routine upsell, pay-in-4), quick add,
   mobile menu, collection filters, sticky product bar. */
(function () {
  const S = window.MaisonTheme || {};
  const FREE = (S.freeShip || 75) * 100;
  const $ = (s, r = document) => r.querySelector(s);
  const money = c => '$' + (c / 100).toFixed(c % 100 ? 2 : 0);
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(r => r.ok ? r.json() : r.json().then(e => Promise.reject(e)));
  let cart = null, upsell = null;

  /* ---------- drawer ---------- */
  function lineHTML(i) {
    return `<div class="ms-line"><a class="ms-visual sm is-cutout" href="${i.url}"><img src="${i.image ? i.image + (i.image.includes('?') ? '&' : '?') + 'width=160' : ''}" alt=""></a>
      <div><small>${i.vendor}</small><p>${i.product_title}</p><small>${i.variant_title || ''}</small>
      <div class="ms-q"><button data-q="${i.key}" data-n="${i.quantity - 1}" aria-label="Less">−</button><span>${i.quantity}</span><button data-q="${i.key}" data-n="${i.quantity + 1}" aria-label="More">+</button></div></div><b>${money(i.final_line_price)}</b></div>`;
  }
  function paint() {
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach(n => { n.textContent = cart.item_count; n.classList.toggle('has', cart.item_count > 0); });
    const d = $('.ms-drawer'); if (!d) return;
    const sub = cart.total_price, left = Math.max(0, FREE - sub);
    $('[data-count]', d).textContent = cart.item_count ? `(${cart.item_count})` : '';
    $('[data-shipmsg]', d).innerHTML = left > 0 ? `You're <b>${money(left)}</b> away from free 2-day shipping` : '<b>Free 2-day shipping unlocked</b> ✓';
    $('[data-meter]', d).style.width = Math.min(100, sub / FREE * 100) + '%';
    $('[data-lines]', d).innerHTML = cart.items.length ? cart.items.map(lineHTML).join('') : '<div class="ms-empty"><p>Your bag is empty.</p><a href="/collections/all">Shop best sellers</a></div>';
    const inBag = upsell && cart.items.some(i => i.product_id === upsell.id);
    $('[data-upsell]', d).innerHTML = cart.items.length && upsell && !inBag && upsell.available ? `<p class="ms-uh">Complete your routine</p><div class="ms-line"><a class="ms-visual sm is-cutout" href="/products/${upsell.handle}"><img src="${upsell.featured_image}" alt=""></a><div><small>${upsell.vendor}</small><p>${upsell.title}</p><small>${money(upsell.price)}</small></div><button class="ms-add-sm" data-add="${upsell.variants[0].id}" data-noopen>Add</button></div>` : '';
    const disc = cart.total_discount || 0;
    $('[data-saverow]', d).hidden = !disc; $('[data-save]', d).textContent = '−' + money(disc);
    $('[data-sub]', d).textContent = money(sub);
    $('[data-bnpl]', d).textContent = sub ? `or 4 interest-free payments of ${money(Math.round(sub / 4))}` : '';
    $('[data-checkout]', d).disabled = !cart.items.length;
  }
  const refresh = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json()).then(c => { cart = c; paint(); return c; });
  const open = () => document.documentElement.classList.add('ms-open');
  const close = () => document.documentElement.classList.remove('ms-open');
  let tt;
  function toast(msg) { const t = $('.ms-toast'); if (!t) return; t.textContent = msg; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('show'), 2400); }

  function add(ids, qty = 1, openIt = true) {
    return post('/cart/add.js', { items: ids.map(id => ({ id: +id, quantity: qty })) })
      .then(r => { refresh().then(() => openIt && open()); toast(ids.length > 1 ? `${ids.length} products added to your bag` : `Added — ${(r.items || [r])[0].product_title}`); })
      .catch(e => toast(e.description || 'Sorry, that item is unavailable'));
  }

  document.addEventListener('click', e => {
    const a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); const q = a.dataset.qtyFrom ? +$(a.dataset.qtyFrom).textContent : 1; add(a.dataset.add.split(','), q, !a.hasAttribute('data-noopen')); return; }
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-close]')) { close(); return; }
    const q = e.target.closest('[data-q]');
    if (q) { post('/cart/change.js', { id: q.dataset.q, quantity: +q.dataset.n }).then(c => { cart = c; paint(); }); return; }
    if (e.target.closest('[data-checkout]')) { location.href = '/checkout'; return; }
    const m = e.target.closest('[data-menu]');
    const sheet = $('#msheet');
    if (m && sheet) { const on = sheet.classList.toggle('open'); m.setAttribute('aria-expanded', on); m.textContent = on ? '×' : '☰'; return; }
    if (sheet && sheet.classList.contains('open') && !e.target.closest('#msheet')) { sheet.classList.remove('open'); const b = $('[data-menu]'); if (b) b.textContent = '☰'; }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  /* ---------- product page qty + sticky bar ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-step]'); if (!b) return;
    const out = $(b.dataset.target); const n = Math.max(1, Math.min(9, +out.textContent + +b.dataset.step)); out.textContent = n;
    const main = $('[data-main-add]'); if (main) main.textContent = `Add to bag — ${money(+main.dataset.price * n)}`;
  });
  const buyrow = $('#buyrow'), sticky = $('#sticky');
  if (buyrow && sticky) new IntersectionObserver(([e]) => sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(buyrow);

  /* ---------- home concern chips ---------- */
  document.querySelectorAll('[data-chip-grid]').forEach(wrap => {
    const grid = $(wrap.dataset.chipGrid), more = $(wrap.dataset.more || '#none');
    wrap.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      wrap.querySelectorAll('button').forEach(x => x.classList.toggle('on', x === b));
      let shown = 0;
      grid.querySelectorAll('[data-tags]').forEach(c => { const ok = b.dataset.c === 'all' || c.dataset.tags.split(',').includes(b.dataset.c); c.hidden = !ok || shown >= 8; if (ok) shown++; });
      if (more) more.href = b.dataset.c === 'all' ? '/collections/all' : '/collections/all/' + b.dataset.c;
    });
  });

  /* ---------- collection filters (client-side, small catalogue) ---------- */
  const side = $('#side');
  if (side) {
    const grid = $('#grid'), cards = [...grid.querySelectorAll('[data-tags]')];
    const url = new URLSearchParams(location.search);
    const state = { vendor: new Set(url.getAll('vendor')), tag: new Set(url.getAll('concern')), type: new Set(), price: new Set() };
    side.querySelectorAll('input[data-g]').forEach(i => { i.checked = state[i.dataset.g].has(i.value); });
    const P = { u75: p => p < 7500, mid: p => p >= 7500 && p <= 20000, o200: p => p > 20000 };
    function run() {
      let n = 0;
      cards.forEach(c => {
        const ok = (!state.vendor.size || state.vendor.has(c.dataset.vendor)) &&
          (!state.tag.size || c.dataset.tags.split(',').some(t => state.tag.has(t))) &&
          (!state.type.size || state.type.has(c.dataset.type)) &&
          (!state.price.size || [...state.price].some(k => P[k](+c.dataset.price)));
        c.hidden = !ok; if (ok) n++;
      });
      const sort = $('#sort').value;
      cards.slice().sort((a, b) => sort === 'low' ? a.dataset.price - b.dataset.price : sort === 'high' ? b.dataset.price - a.dataset.price : a.dataset.i - b.dataset.i).forEach(c => grid.appendChild(c));
      $('#count').textContent = n + (n === 1 ? ' product' : ' products');
      $('#empty').hidden = n > 0;
      $('#chips').innerHTML = Object.entries(state).flatMap(([g, set]) => [...set].map(v => `<button data-g="${g}" data-v="${v}">${(side.querySelector(`input[data-g="${g}"][value="${CSS.escape(v)}"]`) || {}).dataset?.label || v} ×</button>`)).join('');
    }
    side.addEventListener('change', e => { const i = e.target.closest('input[data-g]'); if (!i) return; state[i.dataset.g][i.checked ? 'add' : 'delete'](i.value); run(); });
    $('#chips').addEventListener('click', e => { const b = e.target.closest('button'); if (!b) return; state[b.dataset.g].delete(b.dataset.v); const i = side.querySelector(`input[data-g="${b.dataset.g}"][value="${CSS.escape(b.dataset.v)}"]`); if (i) i.checked = false; run(); });
    $('#clear').onclick = () => { Object.values(state).forEach(s => s.clear()); side.querySelectorAll('input').forEach(i => i.checked = false); run(); };
    $('#sort').onchange = run;
    $('#openF').onclick = () => side.classList.add('open');
    $('#done').onclick = () => side.classList.remove('open');
    run();
  }

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(g => {
    const track = $('[data-track]', g), slides = track.children, n = slides.length;
    const thumbs = g.querySelectorAll('[data-g-to]'), num = $('[data-g-i]', g);
    const prev = $('.g-prev', g), next = $('.g-next', g);
    let i = 0;
    const go = k => track.scrollTo({ left: Math.max(0, Math.min(n - 1, k)) * track.clientWidth });
    const sync = () => {
      i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach((t, k) => t.classList.toggle('on', k === i));
      if (num) num.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      const t = thumbs[i]; if (t) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
    };
    let raf; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); });
    g.addEventListener('click', e => {
      const s = e.target.closest('[data-g-step]'); if (s) return go(i + +s.dataset.gStep);
      const t = e.target.closest('[data-g-to]'); if (t) go(+t.dataset.gTo);
    });
    track.addEventListener('keydown', e => { if (e.key === 'ArrowRight') go(i + 1); if (e.key === 'ArrowLeft') go(i - 1); });
    sync();
  });

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    refresh();
    if (S.upsell) fetch(`/products/${S.upsell}.js`).then(r => r.ok ? r.json() : null).then(p => { if (p) { p.featured_image = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=160'; upsell = p; paint(); } });
    if (location.hash) { const t = document.querySelector(location.hash); if (t && t.tagName === 'DETAILS') t.open = true; }
  });
})();
